import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    S$4 billion for businesses and workers, S$1.6 billion for
                    households, S$800 million health care package
                </li>
                <li>
                    Job Support Scheme: Offset 8% of wages up to a monthly cap
                    of S$3,600 per worker for a 3-month period; taxpaying
                    companies will get 25% rebate on their 2020 taxes capped at
                    S$15,000 per company
                    <ul>
                        <li>
                            <a href="https://www.iras.gov.sg/irashome/Schemes/Businesses/Jobs-Support-Scheme--JSS-/">
                                Job Support Scheme
                            </a>
                            : Employers do not need to apply for the JSS. The
                            grant will be computed based on CPF contribution
                            data. Employers can expect to receive the JSS
                            payment from the Inland Revenue Authority of
                            Singapore (IRAS) by 31 May 2020.
                        </li>
                        <li>
                            <a href="https://www.iras.gov.sg/irashome/Businesses/Companies/Learning-the-basics-of-Corporate-Income-Tax/Overview-of-Corporate-Income-Tax/">
                                Corporate Tax Income Rebate
                            </a>
                            : Companies need not factor in the Corporate Income
                            Tax Rebate when filing the Estimated Chargeable
                            Income and the Income Tax Return (Form C-S/ C) as
                            IRAS will compute it and allow the Rebate
                            automatically.
                        </li>
                    </ul>
                </li>
                <li>
                    Measures to help the tourism sector; Temporary Bridging Loan
                    Program to provide cash flow
                    <ul>
                        <li>
                            <a href="https://www.enterprisesg.gov.sg/financial-assistance/loans-and-insurance/loans-and-insurance/temporary-bridging-loan-for-tourism-sector-enterprises/apply">
                                Application for Temporary Bridging Loan for
                                Tourism Sector Enterprises:
                            </a>
                            Interested enterprises may approach any of the
                            following Participating Financial Institutions to
                            apply for the loan (subject to banks’ credit
                            approval). Link to participating institutions on the
                            next row.
                        </li>
                    </ul>
                </li>
                <li>
                    15% property tax rebate for Changi Airport; rebates on
                    aircraft landing and parking charges and more
                </li>
                <li>
                    S$77-million package for taxis and private hire car drivers
                    (co-funded package); full month rental waiver for F&B
                    establishments
                </li>
                <li>
                    Enterprise Financing Scheme – SME Working Capital Loan (SME
                    WCL)
                    <ul>
                        <li>
                            <a href="https://www.enterprisesg.gov.sg/financial-assistance/loans-and-insurance/loans-and-insurance/enterprise-financing-scheme/sme-working-capital/apply">
                                Application for Enterprise Financing Scheme:
                            </a>
                            Interested enterprises may approach any of the
                            following Participating Financial Institutions to
                            apply for the loan (subject to banks’ credit
                            approval). Download application form (link on the
                            next row).
                        </li>
                    </ul>
                </li>
                <li>
                    Waive license fees for hotels for the rest of 2020.
                    <ul>
                        <li>Applicants can email HLB_Secretariat@hlb.gov.sg</li>
                    </ul>
                </li>
                <li>
                    Help with cleaning costs for hotels that provided
                    accommodation to suspected & confirmed cases: 50% of 3rd
                    party cleaning fees. To qualify, applications must reach STB
                    by 30 Apr 2020. Download application form (link where to
                    find the form on the next column):
                    <ol>
                        <li>
                            You may first submit a soft copy of the signed
                            application form to STB_Hotels@stb.gov.sg.
                        </li>
                        <li>
                            Original hardcopies of the completed and signed
                            application form, along with the supporting
                            documents (please refer to the application form)
                            must be sent to address indicated on the link (next
                            column).
                        </li>
                        <li>
                            <a href="https://www.stb.gov.sg/content/stb/en/assistance-and-licensing/Support-for-Cleaning-Disinfection-Costs.html">
                                Application Process: COVID-19 Cleaning Support
                                for Hotels
                            </a>
                        </li>
                    </ol>
                </li>
                <li>
                    Leave of Absence Support Programme for eligible employers
                    <ul>
                        <li>
                            <a href="https://www.mom.gov.sg/covid-19/loasp">
                                LOA / SHN Support Programme for businesses and
                                SEPs
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Singapore unveils US$4.6 billion economic boost in budget to battle coronavirus outbreak',
            url: 'https://www.scmp.com/week-asia/economics/article/3051166/singapore-unveils-us46-billion-economic-boost-budget-battle',
        },
        {
            title: 'Coping with COVID-19: Economic measures for companies and workers',
            url: 'https://www.gov.sg/article/coping-with-covid-19-economic-measures',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Singapore',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Singapore has announced a stimulus package of S$6.4 (US$4.6) billion
            package.
        </p>
    ),
    sections: [PACKAGE_SECTION],
};

const SingaporeInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SingaporeInfo;
